import React from 'react'
import PropTypes from 'prop-types'

import { ReactComponent as AlertImage } from '../icons/alert-ico.svg'
import { Modal } from 'components/Modal'
import Divider from 'components/Divider'

import { StyledAlertModalContent, StyledAlertText } from '../styled/alert'
import { useTranslation } from 'react-i18next'

import { StyledServiceBtnContainer } from '../styled/service'
import themeStyle from 'config/theme'
import Button from 'components/Button'

const AlertModal = props => {
	const [t] = useTranslation()
	const { width = 400, showBtn = false, onClose, label = t('modal_headers.error'), text, btnText = t('modal_headers.btn_continue') } = props
	return (
		<Modal type={'alert'} label={label} width={width} unmount={onClose}>
			<StyledAlertModalContent>
				<AlertImage />
				<Divider />
				<StyledAlertText>{text}</StyledAlertText>
				{showBtn && <StyledServiceBtnContainer>
					<Button theme={themeStyle} shrink status='transparent' text={btnText} onClick={onClose} />
				</StyledServiceBtnContainer>}
			</StyledAlertModalContent>
		</Modal>
	)
}

AlertModal.propTypes = {
	onClose: PropTypes.func.isRequired,
	label: PropTypes.string,
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	width: PropTypes.number
}

export default AlertModal
